export { default as Benefits } from "./benefits";
export { default as BenefitsSkeleton } from "./benefitsSkeleton";
